import { TransactionTypeEntity } from '../entities/transaction-type-entity';

export default class State {
  loaded = false;

  items: Array<TransactionTypeEntity> = [];
}
